import React from "react";
import Me from "../../assets/me.webp";
import "./Resume.css";

const Resume = () => {
  return (
    <section className="experience-section" name="aboutMe">

      <div className="experience-container">

        {/* Header */}
        <div className="experience-header">

          <span className="experience-eyebrow">
            About My Career
          </span>

          <h2>
            Animation Experience
          </h2>

          <p>
            Below is a selection of my work across previs, postvis,
            2D and 3D animation, graphic design, and motion graphics.
            With a strong foundation in both traditional and digital
            techniques, I have contributed to film and television
            projects with a focus on storytelling, technical accuracy,
            and creative innovation.
          </p>

        </div>


        {/* Intro Row */}
        <div className="experience-intro">

          <div className="experience-list">

            <article className="experience-card">

              <span className="experience-year">
                2021 — 2022
              </span>

              <h3>
                Previs / Postvis Artist / Animator
              </h3>

              <h4>
                Proof Inc. · Los Angeles, CA · Remote
              </h4>

              <ul>
                <li>
                  Projects included Monarch, Shape Island,
                  Chupa, Crater, and Morbius.
                </li>

                <li>
                  Animated characters, creatures, and props
                  while laying out camera work for multiple
                  shots and sequences.
                </li>

                <li>
                  Performed compositing work required for
                  selected shots.
                </li>
              </ul>

            </article>


            <article className="experience-card">

              <span className="experience-year">
                2020 — 2021
              </span>

              <h3>
                Previs Artist / Animator
              </h3>

              <h4>
                Halon Entertainment LLC · Santa Monica, CA
              </h4>

              <ul>
                <li>
                  Project included Disney's Pinocchio.
                </li>

                <li>
                  Animated characters, creatures, and props
                  for several shots and sequences.
                </li>

                <li>
                  Created and refined camera layouts.
                </li>

                <li>
                  Created 3D animated scenes to help clients
                  visualize shots before filming.
                </li>

                <li>
                  Integrated animation sequences from Maya
                  into Unreal Engine.
                </li>
              </ul>

            </article>

          </div>


          {/* Portrait */}
          <div className="experience-portrait">

            <div className="portrait-frame">

              <img
                src={Me}
                alt="Alwyn Funa"
                loading="lazy"
              />

              <div className="portrait-accent"></div>

            </div>

            <div className="portrait-label">
              <span>Animator</span>
              <span>Designer</span>
              <span>Storyteller</span>
            </div>

          </div>

        </div>


        {/* More Experience */}
        <div className="experience-more">

          <article className="experience-card">

            <span className="experience-year">
              2020
            </span>

            <h3>
              Previs Artist / Animator
            </h3>

            <h4>
              Proof Inc. · Los Angeles, CA · Remote
            </h4>

            <ul>
              <li>
                Project included The Tomorrow War.
              </li>

              <li>
                Animated characters, creatures, and props
                while laying out camera work for multiple
                shots and sequences.
              </li>

              <li>
                Completed effects work required for
                selected shots.
              </li>

              <li>
                Created 3D animated scenes to help clients
                visualize shots before filming.
              </li>

              <li>
                Integrated animation sequences from Maya
                into Unreal Engine.
              </li>
            </ul>

          </article>


          <article className="experience-card">

            <span className="experience-year">
              2018 — 2019
            </span>

            <h3>
              Previs / Postvis Artist / Animator
            </h3>

            <h4>
              Halon Entertainment LLC · Santa Monica, CA
            </h4>

            <ul>
              <li>
                Projects included X-Men: Dark Phoenix,
                Ford v Ferrari, and The Call of the Wild.
              </li>

              <li>
                Animated characters, creatures, and props
                while laying out camera work for multiple
                shots and sequences.
              </li>

              <li>
                Completed effects work required for
                selected shots.
              </li>

              <li>
                Created 3D animated scenes to help clients
                visualize shots before filming.
              </li>

              <li>
                Integrated animation sequences from Maya
                into Unreal Engine.
              </li>
            </ul>

          </article>

        </div>

      </div>

    </section>
  );
};

export default Resume;